<template>
  <div class="editGallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        编辑广告
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="flush()">刷新</div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="filtrate_head">
        <div class="filtrate_filer">编辑广告</div>
      </div>
      <div class="table">
        <el-form label-width="100px" style="padding-top:30px; margin: 0 auto">
          <el-form-item label="广告名称:">
            <el-input v-model="title" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item
            :label="'广告:' + (index + 1)"
            v-for="(item , index) in arr_banner"
            :key="index"
          >
            <div class="grid-content">
              <div style="display:flex;justify-content: space-between;">
                <div>
                  <el-upload
                    class="upload-demo"
                    action
                    :limit="1"
                    :auto-upload="false"
                    :on-change=" (file)=> list_img_file(index, file)"
                  >
                    <el-button size="small" type="primary">点击上传图片</el-button>
                  </el-upload>
                </div>
                <div>
                  <el-button v-if="arr_banner.length > 1" @click="red(index)" size="small">删除</el-button>
                </div>
              </div>
              <img v-if="item.img" :src=" serve + item.img " width="300px" height="150px" />
            </div>
            <div style="margin-top:20px">
              <el-input v-model="item.link" placeholder="输入广告连接">
                <template slot="prepend">链接地址</template>
              </el-input>
            </div>
          </el-form-item>
          <!-- 
          <el-form-item label="广告2:">
            <div class="grid-content">
              <input
                type="file"
                id="file"
                accept="image/png, image/jpeg, image/jpg"
                @change="getImage2($event)"
              />
              <img v-show="show2" v-bind:src="serve+'/'+img2" width="300px" height="150px" />
              <img v-show="shw2" v-bind:src="src2" width="300px" height="150px" />
            </div>
            <div style="margin-top:20px">
              <el-input v-model="link2" placeholder="输入广告连接">
                <template slot="prepend">链接地址</template>
              </el-input>
            </div>
          </el-form-item>

          <el-form-item label="广告3:">
            <div class="grid-content">
              <input
                type="file"
                id="file"
                accept="image/png, image/jpeg, image/jpg"
                @change="getImage3($event)"
              />
              <img v-show="show3" v-bind:src="serve+'/'+img3" width="300px" height="150px" />
              <img v-show="shw3" v-bind:src="src3" width="300px" height="150px" />
              <div class="notice">图片必须为jpg或png格式，且大小不能超过5mb</div>
            </div>
            <div style="margin-top:20px">
              <el-input v-model="link3" placeholder="输入广告连接">
                <template slot="prepend">链接地址</template>
              </el-input>
            </div>
          </el-form-item>-->
          <el-form-item>
            <el-button @click="add" type="danger">添加其他广告图片 +</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="button" @click="submit()">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  data() {
    return {
      arr_banner: [
        {
          img: "",
          link: ""
        }
      ],
      serve: this.$store.state.serve,
      id: this.$route.params.id,
      username: "",
      token: "",
      title: ""
    };
  },
  created() {
    this.$store.state.leftTitle = "横幅广告";
    this.$store.state.topActiveId = 7;
    this.flush();
  },
  methods: {
    add() {
      this.arr_banner.push({
        img: "",
        link: ""
      });
    },
    red(i) {
      this.arr_banner.splice(i, 1);
    },
    list_img_file(e, file) {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let formData = new FormData();
      formData.append("image", file.raw);
      formData.append("username", this.username);
      formData.append("token", this.token);
      this.axios
        .post(this.serve + "/admin/banner_img_upload", formData, config)
        .then(res => {
          if (res.data.status == "success") {
            this.arr_banner[e].img = res.data.data;
          }
        });
    },
    flush() {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/banner_ad_detail", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id
          }
        })
        .then(res => {
          var json = res.data.data;
          if (res.data.status == "success") {
            that.title = json.title;
            that.arr_banner = json.image_arr;
          }
        });
    },
    submit() {
      // if ((this.shw1 && this.shw2 && this.shw3) || (!this.shw1 && !this.shw2 && !this.shw3)) {
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      const formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("title", this.title);
      formData.append("banner_id", this.id);
      formData.append("arr_banner", JSON.stringify(this.arr_banner));
      
      this.axios
        .post(this.serve + "/admin/banner", formData, config)
        .then(res => {
          if (res.data.status == "success") {
            loading.close();
            that.$router.push({ path: "/admin/g_advertising1" });
          }else if(res.data.code == '403'){
            loading.close();
            that.$message.error(res.data.msg); 
          }  else if (res.data.status == "error") {
            loading.close();
            this.$message.error(res.data.msg);
          }
        })
        .catch(function(err) {
          loading.close();
          that.$message.error("操作失败");
        });
      // } else {
      //   this.$confirm("修改图片时必须三张全部修改", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      //   });
      // }
    }
  }
};
</script>
<style lang="scss">
.editGallery {
  min-height: 1000px;
  #tetx {
    width: 330px;
    height: 200px;
  }
  background: #f5f5f5;
  color: #333;

  .filtrate_head {
    width: 100%;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }
    .filtrate_seek {
      position: relative;
      font-size: 16px;
      // border-bottom: 1px solid rgba(221, 221, 221, 1);
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 86px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      // margin: 24px 0 0 17px;
      display: flex;
      align-items: center;
      background: #fff;
      > strong {
        font-size: 16px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 24px;
        margin-right: 6px;
      }
      .filtrate_seek_sousuo {
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        width: 74px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        position: absolute;
        right: 18px;
        top: 29px;
        cursor: pointer;
      }
      .filtrate_seek_sousuo:hover {
        color: #0099ff;
      }
    }
    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }

  textarea {
    height: 300px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    background-color: #fff;
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 450px;
    margin: 0 auto;
    padding: 20px 0;
    align-items: right;
  }
  .table {
    display: flex;
  }

  .label {
    line-height: 40px;
  }
  .button {
    width: 190px;
    height: 44px;
    background: rgba(0, 153, 255, 1);
    border-radius: 4px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .button:hover {
    background: rgba(46, 172, 255, 1);
  }

  .notice {
    font-size: 13px;
    color: #666;
  }
}
</style>
